import React from "react";
import { colors, radius, shadow } from "./tokens";
import { XIcon } from "./icons";

// Fenêtre de consultation générique — permet à l'équipe de modération de vérifier le contenu
// réel d'une publication/un Flash/une vibe (image, texte complet, coordonnées) avant de décider
// de suspendre/supprimer, plutôt que de juger sur les seules colonnes résumées d'un tableau.
export function PreviewModal({ open, onClose, title, subtitle, image, fields, body }: {
  open: boolean; onClose: () => void; title: string; subtitle?: string; image?: string | null;
  fields?: { label: string; value: React.ReactNode }[]; body?: string | null;
}) {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, backgroundColor: "rgba(11,11,15,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 24 }}
    >
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: colors.card, borderRadius: radius.lg, boxShadow: shadow, width: "100%", maxWidth: 560, maxHeight: "85vh", overflowY: "auto" }}>
        {image && (
          <img src={image} alt="" style={{ width: "100%", maxHeight: 320, objectFit: "cover", borderTopLeftRadius: radius.lg, borderTopRightRadius: radius.lg, display: "block" }} />
        )}
        <div style={{ padding: 24 }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: subtitle ? 4 : 16 }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: colors.text }}>{title}</div>
            <button onClick={onClose} style={{ border: "none", background: colors.bg, borderRadius: radius.sm, cursor: "pointer", padding: 6, display: "flex", flexShrink: 0 }}>
              <XIcon size={14} color={colors.textMuted} />
            </button>
          </div>
          {subtitle && <div style={{ fontSize: 13, color: colors.textMuted, marginBottom: 16 }}>{subtitle}</div>}

          {fields && fields.length > 0 && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: body ? 18 : 0 }}>
              {fields.map((f, i) => (
                <div key={i}>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: colors.textFaint, textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 2 }}>{f.label}</div>
                  <div style={{ fontSize: 13.5, color: colors.text }}>{f.value}</div>
                </div>
              ))}
            </div>
          )}

          {body && (
            <div style={{ fontSize: 14, color: colors.text, lineHeight: 1.6, whiteSpace: "pre-wrap", backgroundColor: colors.bg, borderRadius: radius.sm, padding: 14 }}>
              {body}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
